import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { getRawColor } from 'shared/lib/getRawColor'
import { shareText } from 'shared/lib/share'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { message } from 'shared/ui/message'

import s from './styles.module.scss'

interface Props {
  shareUrl: string
  text?: string
  onClick?: () => void
}

export const ShareButton = ({ shareUrl, onClick, text }: Props) => {
  const { t } = useTranslation()

  const handleShare = () => {
    shareText({
      url: shareUrl,
      title: text,
      onCopied: () => {
        message.copy(t('link_copied_to_clipboard'))
      },
    })

    onClick?.()
  }

  return (
    <button
      className={clsx(s.shareButton)}
      onClick={handleShare}
    >
      <AppIcon
        width={24}
        height={24}
        className={s.icon}
        id={AllIcons.SHARE_TOUR}
        color={getRawColor('--blue-5')}
      />
    </button>
  )
}
